import { CapabilityGate, SubCapabilityKey } from "@next-platform/client-common-core/infra/application/capabilities";

import type { IAdvancedOptionsProps } from "@/components/AvatarGeneratorModal/types";

import { AdvancedOptions } from "./AdvancedOptions";

export default function CapabilityAdvancedOptions(props: IAdvancedOptionsProps) {
  return (
    <CapabilityGate capability={SubCapabilityKey.ChatImageImageGenerationSettings}>
      <AdvancedOptions {...props} />
    </CapabilityGate>
  );
}
